module.exports = __webpack_public_path__ + "static/img/kuodashengchan.ad383e56.png";